import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { RecommendationProjectTypeEnum } from '../../../types';
import {
  setSelectedRecommendationTypeAction,
  changePaginationAction,
} from '../../../store/projects/actions';

/**
 * Custom hook for project-related actions
 * Following Clean Code principle: Single responsibility - only handles actions
 */
export const useProjectActions = () => {
  const dispatch = useDispatch();

  /**
   * Handles recommendation type change with pagination reset
   * Following Clean Code principle: Self-documenting function name
   */
  const handleRecommendationTypeChange = useCallback(
    (type: RecommendationProjectTypeEnum) => {
      dispatch(setSelectedRecommendationTypeAction(type));
      dispatch(changePaginationAction({ page: 1 }));
    },
    [dispatch],
  );

  return {
    handleRecommendationTypeChange,
  };
};
